import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "b5d7bcba8182d8381799a2d988e4a9e7",
  "use": "b5d7bcba8182d8381799a2d988e4a9e7-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 56 56\" id=\"b5d7bcba8182d8381799a2d988e4a9e7\">\n<path fill=\"\" d=\"M28.5,36.187l21.102-21.102c0.892-0.892,2.337-0.892,3.229,0c0.892,0.891,0.892,2.337,0,3.228L30.229,40.915\n\tc-0.475,0.475-1.107,0.697-1.729,0.666c-0.622,0.031-1.254-0.191-1.729-0.666L4.169,18.313c-0.892-0.891-0.892-2.337,0-3.228\n\tc0.892-0.892,2.337-0.892,3.229,0L28.5,36.187z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol